import { isNewQuestionnaire } from '@/shared/questionnaires'
import { insertManifest } from '@ui/shared-utils/src/index'

export default function (assessmentConfig) {
  return new Promise((resolve) => {
    const {
      name,
      site
    } = assessmentConfig.siteInfo

    // Add page title
    appendTag(`<title>${name}</title>`)

    // Insert manifest json for PWA
    insertManifest()

    appendBrandStyleTags(site, assessmentConfig.service)

    // Favicons and mobile header
    if (site === 'zava') {
      zavaTags.forEach((el) => appendTag(el))
    } else if (site === 'dred') {
      dredTags.forEach((el) => appendTag(el))
    } else if (site === 'tosca') {
      toscaTags.forEach((el) => appendTag(el))
    }

    // Add correct class to Loader as soon as it is available (and loader present)
    const loaderElement = window.document.getElementById('loader')
    loaderElement && loaderElement.classList.add(site)

    const gmapsScript = document.createElement('script')
    gmapsScript.src = `//maps.googleapis.com/maps/api/js?v=3&key=${window.siteInfo.assessmentGoogleMapsAPIKey}`
    gmapsScript.type = 'text/javascript'
    gmapsScript.async = true
    gmapsScript.defer = true
    document.head.appendChild(gmapsScript)

    const recaptchaScript = document.createElement('script')
    recaptchaScript.src = 'https://www.google.com/recaptcha/api.js?render=explicit'
    recaptchaScript.type = 'text/javascript'
    recaptchaScript.async = true
    recaptchaScript.defer = true
    document.head.appendChild(recaptchaScript)
    resolve()
  })
}

const createElement = (string) => {
  const element = window.document.createElement('div')
  element.innerHTML = string
  return element.firstChild
}
const appendTag = (string) => window.document.head.append(createElement(string))
const zavaTags = [
  '<link rel="apple-touch-icon" sizes="57x57" href="assets/images/favicons/apple-icon-57x57.png" />',
  '<link rel="apple-touch-icon" sizes="60x60" href="assets/images/favicons/apple-icon-60x60.png" />',
  '<link rel="apple-touch-icon" sizes="72x72" href="assets/images/favicons/apple-icon-72x72.png" />',
  '<link rel="apple-touch-icon" sizes="76x76" href="assets/images/favicons/apple-icon-76x76.png" />',
  '<link rel="apple-touch-icon" sizes="114x114" href="assets/images/favicons/apple-icon-114x114.png" />',
  '<link rel="apple-touch-icon" sizes="120x120" href="assets/images/favicons/apple-icon-120x120.png" />',
  '<link rel="apple-touch-icon" sizes="144x144" href="assets/images/favicons/apple-icon-144x144.png" />',
  '<link rel="apple-touch-icon" sizes="152x152" href="assets/images/favicons/apple-icon-152x152.png" />',
  '<link rel="apple-touch-icon" sizes="180x180" href="assets/images/favicons/apple-icon-180x180.png" />',
  '<link rel="icon" type="image/png" sizes="192x192" href="assets/images/favicons/android-icon-192x192.png" />',
  '<link rel="icon" type="image/png" sizes="96x96" href="assets/images/favicons/favicon-96x96.png" />',
  '<link rel="icon" type="image/png" sizes="32x32" href="assets/images/favicons/favicon-32x32.png" />',
  '<link rel="icon" type="image/png" sizes="16x16" href="assets/images/favicons/favicon-16x16.png" />',
  '<meta name="msapplication-TileColor" content="#0F62F4" />',
  '<meta name="msapplication-TileImage" content="assets/images/favicons/ms-icon-144x144.png" />',
  '<meta name="msvalidate.01" content="DFA0EDE64C29F5E07C8C9F865B66ECA1" />',
  '<meta name="theme-color" content="#0F62F4" />'
]
const dredTags = [
  '<meta name="theme-color" content="#3A9F9D">'
]
const toscaTags = [
  '<link rel="apple-touch-icon" sizes="57x57" href="assets/images/favicons/asda/apple-icon-57x57.png" />',
  '<link rel="apple-touch-icon" sizes="60x60" href="assets/images/favicons/asda/apple-icon-60x60.png" />',
  '<link rel="apple-touch-icon" sizes="72x72" href="assets/images/favicons/asda/apple-icon-72x72.png" />',
  '<link rel="apple-touch-icon" sizes="76x76" href="assets/images/favicons/asda/apple-icon-76x76.png" />',
  '<link rel="apple-touch-icon" sizes="114x114" href="assets/images/favicons/asda/apple-icon-114x114.png" />',
  '<link rel="apple-touch-icon" sizes="120x120" href="assets/images/favicons/asda/apple-icon-120x120.png" />',
  '<link rel="apple-touch-icon" sizes="144x144" href="assets/images/favicons/asda/apple-icon-144x144.png" />',
  '<link rel="apple-touch-icon" sizes="152x152" href="assets/images/favicons/asda/apple-icon-152x152.png" />',
  '<link rel="apple-touch-icon" sizes="180x180" href="assets/images/favicons/asda/apple-icon-180x180.png" />',
  '<link rel="icon" type="image/png" sizes="192x192" href="assets/images/favicons/asda/android-icon-192x192.png" />',
  '<link rel="icon" type="image/png" sizes="48x48" href="assets/images/favicons/asda/favicon-48x48.png" />',
  '<link rel="icon" type="image/png" sizes="32x32" href="assets/images/favicons/asda/favicon-32x32.png" />',
  '<link rel="icon" type="image/png" sizes="16x16" href="assets/images/favicons/asda/favicon-16x16.png" />',
  '<meta name="msapplication-TileColor" content="#0F62F4" />',
  '<meta name="msapplication-TileImage" content="assets/images/favicons/asda/ms-icon-144x144.png" />',
  '<meta name="msvalidate.01" content="DFA0EDE64C29F5E07C8C9F865B66ECA1" />',
  '<meta name="theme-color" content="#0F62F4" />'
]

const appendBrandStyleTags = (site, serviceDetails) => {
  appendTag(`<link rel="preload" href="assets/stylesheets/shell-${site}.css" as="style" />`)
  appendTag(`<link rel="stylesheet" href="assets/stylesheets/shell-${site}.css" />`)
  if (isNewQuestionnaire(serviceDetails)) {
    // Loading the style with media 'print' makes the style load asynchronously
    appendTag(`<link rel="stylesheet" href="assets/stylesheets/site-${site}.css" media="print" onload="this.media='all'" />`)
  } else {
    appendTag(`<link rel="stylesheet" href="assets/stylesheets/site-${site}.css" />`)
  }
}
